import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import {
  insertShift,
  getShift,
  getCategorys,
  deleteShift,
  getCompanys,
  getDepartments,
} from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import FilterComponent from "../pages/FilterComponent";
import jsPDF from "jspdf";
import Select from "react-select";
export default function Shift() {
  const UID = localStorage.getItem("userId");
  const [uFetch, setUfetch] = useState({
    UserId: UID,
  });
  const [addShiftModal, setAddShiftModal] = useState(false);
  const [editShiftModal, setEditShiftModal] = useState(false);
  const [shifts, setShifts] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [categorys, setCategorys] = useState([]);
  const [Department, setDepartment] = useState([]);

  const [loading, setLoading] = useState(false);
  const [companyDetails, setCompanyDetails] = useState([])

  const [shiftData, setShiftData] = useState({
    Name: "",
    Narration: "",
    StartTime: "",
    EndTime: "",
    MinOverTime: "",
    MinWorkingHour: "",
    DepartmentId: [],
    WorkingHour: "",
    MaxWorkingHour: "",
    HalfDay: "",
    GracePeriod: "",
    Remarks: "",
    UserId: UID,
    allowHalfday: false,
    HalfDayStartTimeMorning: "",
    HalfDayEndTimeMorning: "",
    WorkingHourMorningHalfDay: "",
    HalfDayStartTimeEvening: "",
    HalfDayEndTimeEvening: "",
    WorkingHourEveningHalfDay: "",
  });

  function convertTimeToHourMinuteFormat(time) {
    if (!time) {
      return "00:00";
    }

    const date = new Date(time);
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();

    // Format hours and minutes to ensure two digits
    const formattedHours = String(hours).padStart(2, "0"); // Use padStart for zero-padding
    const formattedMinutes = String(minutes).padStart(2, "0"); // Use padStart for zero-padding

    return `${formattedHours}:${formattedMinutes}`;
  }



  const openAddShiftModal = () => {
    setShiftData({
      Name: "",
      Narration: "",
      StartTime: "",
      EndTime: "",
      MinOverTime: "",
      MinWorkingHour: "",
      MaxWorkingHour: "",
      HalfDay: "",
      GracePeriod: "",
      Remarks: "",
      UserId: UID,
      allowHalfday: false,
      HalfDayStartTimeMorning: "",
      HalfDayEndTimeMorning: "",
      WorkingHourMorningHalfDay: "",
      HalfDayStartTimeEvening: "",
      HalfDayEndTimeEvening: "",
      WorkingHourEveningHalfDay: "",
    });
    setAddShiftModal(!addShiftModal);
  };
  const openEditShiftModal = (data) => {
    console.log(data, 'ssssssss');

    // Helper function to format time into "Xh Ym"
    function convertTimeToHourMinuteFormat(time) {
      const date = new Date(time);
      const hours = date.getUTCHours();
      const minutes = date.getUTCMinutes();
      return `${hours}h ${minutes}m`;
    }

    // Find DepartmentName (optional, as it's not used in the Select component)
    const DepartmentName = Department?.find((item) => item.Id === data?.DepartmentIds);

    // Convert DepartmentId string to an array
    const departmentIds = data?.DepartmentIds ? data.DepartmentIds.split(",") : [];

    // Find CategoryName (if needed)
    const CategoryName = categorys.find((item) => item.Id === data?.CategoryId);

    setShiftData({
      ...data,
      CategoryId: data?.CategoryId,
      DepartmentId: departmentIds, // Set as an array
      Department: DepartmentName?.Name || "", // Optional, if used elsewhere
      CategoryName: CategoryName?.Name || "", // Default to empty string if not found
      UserId: UID || "", // Ensure UserId is defined

    });

    setEditShiftModal(!editShiftModal);
  };

  const fetchDepartment = async () => {
    setLoading(true)
    try {
      const res = await getDepartments(UID)
      setDepartment(res.data.data)
    } catch {
      setLoading(false)
    }
  }


  useEffect(() => {
    setLoading(true);
    fetchShifts();
    fetchDepartment()
  }, []);

  useEffect(() => {
    if (shifts && shifts.length > 0) {
      const updatedData = shifts.map((item, index) => ({
        Slno: index + 1,
        Id: item.Id || "",
        Name: item.Name || "",
        Narration: item.Narration || "",
        StartTime: item.StartTime || "",
        EndTime: item.EndTime || "",
        MinOverTime: item.MinOverTime || "",
        HalfDay: item.HalfDay || "",
        MinWorkingHour: item.MinWorkingHour || "",
        MaxWorkingHour: item.MaxWorkingHour || "",
        GracePeriod: item.GracePeriod || "",
        Remarks: item.Remarks || "",
        DepartmentIds: item.DepartmentId || "",
        UserId: UID,
        allowHalfday: item.allowHalfday,
        HalfDayStartTimeMorning: item.HalfDayStartTimeMorning,
        HalfDayEndTimeMorning: item.HalfDayEndTimeMorning,
        WorkingHourMorningHalfDay: item.WorkingHourMorningHalfDay,
        HalfDayStartTimeEvening: item.HalfDayStartTimeEvening,
        HalfDayEndTimeEvening: item.HalfDayEndTimeEvening,
        WorkingHourEveningHalfDay: item.WorkingHourEveningHalfDay,
        // DepartmentId: item.DepartmentId || "",
      }));
      setDataFilter(updatedData);
    } else {
      setDataFilter([]);
    }
  }, [shifts]);

  const fetchShifts = async () => {
    setLoading(true);
    try {
      const data = await getShift(UID);
      const formattedShifts = data.data.data.map((shift) => {
        const convertedEndTime = convertTimeToHourMinuteFormat(shift.EndTime);
        const convertedStartTime = convertTimeToHourMinuteFormat(shift.StartTime);
        const convertedMaxWorkingHour = convertTimeToHourMinuteFormat(shift.MaxWorkingHour);
        const convertedMinOverTime = convertTimeToHourMinuteFormat(shift.MinOverTime);
        const convertedMinWorkingHour = convertTimeToHourMinuteFormat(shift.MinWorkingHour);
        const convertedHalfDay = convertTimeToHourMinuteFormat(shift.HalfDay);
        const convertedSTMH = convertTimeToHourMinuteFormat(shift.HalfDayStartTimeMorning);
        const convertedETMH = convertTimeToHourMinuteFormat(shift.HalfDayEndTimeMorning);
        const convertedWHMH = convertTimeToHourMinuteFormat(shift.WorkingHourMorningHalfDay);
        const convertedSTEH = convertTimeToHourMinuteFormat(shift.HalfDayStartTimeEvening);
        const convertedETEH = convertTimeToHourMinuteFormat(shift.HalfDayEndTimeEvening);
        const convertedWHEH = convertTimeToHourMinuteFormat(shift.WorkingHourEveningHalfDay);

        return {
          ...shift,
          EndTime: convertedEndTime,
          StartTime: convertedStartTime,
          MaxWorkingHour: convertedMaxWorkingHour,
          MinOverTime: convertedMinOverTime,
          MinWorkingHour: convertedMinWorkingHour,
          HalfDay: convertedHalfDay,
          HalfDayStartTimeMorning: convertedSTMH,
          HalfDayEndTimeMorning: convertedETMH,
          WorkingHourMorningHalfDay: convertedWHMH,
          HalfDayStartTimeEvening: convertedSTEH,
          HalfDayEndTimeEvening: convertedETEH,
          WorkingHourEveningHalfDay: convertedWHEH,
        };
      });

      setShifts(formattedShifts);
      setIsFilterVisible(false);
    } catch (error) {
      console.error("Error fetching shifts", error);
    }
    setLoading(false);
  };




  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;

    setShiftData((prev) => {
      let updatedData = { ...prev };

      if (type === "checkbox") {
        updatedData = {
          ...updatedData,
          [name]: checked,
          [`${name}Error`]: ""
        };
      } else {
        updatedData = {
          ...updatedData,
          [name]: value,
          [`${name}Error`]: ""
        };
      }

      // If StartTime or EndTime changes, clear MinWorkingHour and MaxWorkingHour
      if (name === "StartTime" || name === "EndTime") {
        updatedData.MinWorkingHour = "";
        updatedData.MaxWorkingHour = "";
      }

      // ⏱️ Auto-calculate Morning HalfDay Working Hour
      if (
        (name === "HalfDayStartTimeMorning" || name === "HalfDayEndTimeMorning") &&
        updatedData.HalfDayStartTimeMorning &&
        updatedData.HalfDayEndTimeMorning
      ) {
        const start = new Date(`1970-01-01T${updatedData.HalfDayStartTimeMorning}:00`);
        const end = new Date(`1970-01-01T${updatedData.HalfDayEndTimeMorning}:00`);
        const diffMs = end - start;
        if (diffMs > 0) {
          const hours = Math.floor(diffMs / (1000 * 60 * 60));
          const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
          updatedData.WorkingHourMorningHalfDay = `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}`;
        }
      }

      // ⏱️ Auto-calculate Evening HalfDay Working Hour
      if (
        (name === "HalfDayStartTimeEvening" || name === "HalfDayEndTimeEvening") &&
        updatedData.HalfDayStartTimeEvening &&
        updatedData.HalfDayEndTimeEvening
      ) {
        const start = new Date(`1970-01-01T${updatedData.HalfDayStartTimeEvening}:00`);
        const end = new Date(`1970-01-01T${updatedData.HalfDayEndTimeEvening}:00`);
        const diffMs = end - start;
        if (diffMs > 0) {
          const hours = Math.floor(diffMs / (1000 * 60 * 60));
          const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
          updatedData.WorkingHourEveningHalfDay = `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}`;
        }
      }

      return updatedData;
    });
  };




  const handleBlur = () => {
    const parseTime = (time) => {
      const [hours, minutes] = time.split(":").map(Number);
      return hours * 60 + minutes; // Convert to total minutes
    };

    const isValidTimeFormat = (time) => {
      // Allow 00:00 to 23:59 and 24:00
      const timeRegex = /^((([01][0-9])|(2[0-3])):[0-5][0-9])|(24:00)$/;
      return timeRegex.test(time);
    };

    const { MinWorkingHour, MaxWorkingHour, WorkingHour, MinOverTime, HalfDay } = shiftData;
    let minError = "",
      maxError = "",
      minOverTimeError = "",
      halfDayError = "";

    // Validate MinWorkingHour format
    if (MinWorkingHour && !isValidTimeFormat(MinWorkingHour)) {
      minError = "Enter time in HH:MM format (e.g., 03:15).";
    } else if (
      WorkingHour &&
      MinWorkingHour &&
      parseTime(MinWorkingHour) > parseTime(WorkingHour)
    ) {
      minError = "Min Working Hour must be less than or equal to Working Hour.";
    }

    // Validate MaxWorkingHour format
    if (MaxWorkingHour && !isValidTimeFormat(MaxWorkingHour)) {
      maxError = "Enter time in HH:MM format (e.g., 03:15).";
    } else if (
      WorkingHour &&
      MaxWorkingHour &&
      parseTime(MaxWorkingHour) < parseTime(WorkingHour)
    ) {
      maxError = "Max Working Hour must be greater than or equal to Working Hour.";
    }

    // Validate MinOverTime format
    if (MinOverTime && !isValidTimeFormat(MinOverTime)) {
      minOverTimeError = "Enter time in HH:MM format (e.g., 03:15).";
    }

    // Validate HalfDay format
    if (HalfDay && !isValidTimeFormat(HalfDay)) {
      halfDayError = "Enter time in HH:MM format (e.g., 03:15).";
    } else if (
      WorkingHour &&
      HalfDay &&
      parseTime(HalfDay) > parseTime(WorkingHour)
    ) {
      halfDayError = "Half Day must be less than or equal to Working Hour.";
    }

    setShiftData((prev) => ({
      ...prev,
      MinWorkingHourError: minError,
      MaxWorkingHourError: maxError,
      MinOverTimeError: minOverTimeError,
      HalfDayError: halfDayError,
    }));
  };

  const [maxMwh, setMaxMwh] = useState(Boolean);
  const [minimumMwh, setMinimumMwh] = useState(Boolean);
  const [minOt, setMinOt] = useState(Boolean);

  // MinWorkingHour
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const timeFormatRegex = /^\d{2}:\d{2}$/;

      if (timeFormatRegex.test(shiftData?.MaxWorkingHour)) {
        setMaxMwh(true);
      } else {
        setMaxMwh(false);
      }

      if (timeFormatRegex.test(shiftData?.MinWorkingHour)) {
        setMinimumMwh(true);
      } else {
        setMinimumMwh(false);
      }

      if (timeFormatRegex.test(shiftData?.MinOverTime)) {
        setMinOt(true);
      } else {
        setMinOt(false);
      }

      console.debug("shiftData", shiftData);

      const today = new Date();
      const dateString = today.toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format

      // Handle 24:00 case for StartTime and EndTime
      const startTime = shiftData.StartTime === "24:00" ? "23:59:59.999" : shiftData.StartTime;
      const endTime = shiftData.EndTime === "24:00" ? "23:59:59.999" : shiftData.EndTime;

      const start = new Date(`${dateString}T${startTime}:00Z`);
      const end = new Date(`${dateString}T${endTime}:00Z`);

      // Adjust for 24:00 by adding 1 millisecond to make it a full day
      if (shiftData.EndTime === "24:00") {
        end.setTime(end.getTime() + 1);
      }
      if (shiftData.StartTime === "24:00") {
        start.setTime(start.getTime() + 1);
      }

      const workingTime = end - start;

      const hours = Math.floor(workingTime / (1000 * 60 * 60));
      const minutes = Math.floor((workingTime % (1000 * 60 * 60)) / (1000 * 60));

      // Special case for 24 hours
      let worktimeFormat;
      if (hours === 24 && minutes === 0) {
        worktimeFormat = "24:00";
      } else {
        worktimeFormat = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
      }

      console.debug("workingTime", worktimeFormat);

      // Handle 24:00 case for Min/MaxWorkingHour
      const minWH = shiftData.MinWorkingHour === "24:00" ? "23:59:59.999" : shiftData.MinWorkingHour;
      const maxWH = shiftData.MaxWorkingHour === "24:00" ? "23:59:59.999" : shiftData.MaxWorkingHour;

      const wroktimeMs = worktimeFormat === "24:00"
        ? 24 * 60 * 60 * 1000
        : new Date(`${dateString}T${worktimeFormat}:00Z`).getTime();

      const minimumWorkTimeMs = shiftData.MinWorkingHour === "24:00"
        ? 24 * 60 * 60 * 1000
        : new Date(`${dateString}T${minWH}:00Z`).getTime();

      const maximumWorkTimeMs = shiftData.MaxWorkingHour === "24:00"
        ? 24 * 60 * 60 * 1000
        : new Date(`${dateString}T${maxWH}:00Z`).getTime();

      setLoading(true);
      const response = await insertShift({
        ...shiftData,
        // Pass the original values (including 24:00) to the API
        StartTime: shiftData.StartTime,
        EndTime: shiftData.EndTime,
        MinWorkingHour: shiftData.MinWorkingHour,
        MaxWorkingHour: shiftData.MaxWorkingHour
      });

      if (response.data.StatusCode === 200) {
        toast.success(response.data.message);
        fetchShifts();
        openAddShiftModal();
      }
    } catch (error) {
      toast.error("Something went wrong, please try again");
      console.error("Error adding shift:", error);
    }
    setLoading(false);
  };

  // edit
  const handleEdit = async (e) => {
    e.preventDefault();


    try {
      const timeFormatRegex = /^\d{2}:\d{2}$/;

      if (timeFormatRegex.test(shiftData?.MaxWorkingHour)) {
        setMaxMwh(true);
      } else {
        setMaxMwh(false);
      }

      if (timeFormatRegex.test(shiftData?.MinWorkingHour)) {
        setMinimumMwh(true);
      } else {
        setMinimumMwh(false);
      }

      if (timeFormatRegex.test(shiftData?.MinOverTime)) {
        setMinOt(true);
      } else {
        setMinOt(false);
      }

      console.debug("shiftData", shiftData);

      const today = new Date();
      const dateString = today.toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format

      // Handle 24:00 case for StartTime and EndTime
      const startTime = shiftData.StartTime === "24:00" ? "23:59:59.999" : shiftData.StartTime;
      const endTime = shiftData.EndTime === "24:00" ? "23:59:59.999" : shiftData.EndTime;

      const start = new Date(`${dateString}T${startTime}:00Z`);
      const end = new Date(`${dateString}T${endTime}:00Z`);

      // Adjust for 24:00 by adding 1 millisecond to make it a full day
      if (shiftData.EndTime === "24:00") {
        end.setTime(end.getTime() + 1);
      }
      if (shiftData.StartTime === "24:00") {
        start.setTime(start.getTime() + 1);
      }

      const workingTime = end - start;

      const hours = Math.floor(workingTime / (1000 * 60 * 60));
      const minutes = Math.floor((workingTime % (1000 * 60 * 60)) / (1000 * 60));

      // Special case for 24 hours
      let worktimeFormat;
      if (hours === 24 && minutes === 0) {
        worktimeFormat = "24:00";
      } else {
        worktimeFormat = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
      }

      console.debug("workingTime", worktimeFormat);

      // Handle 24:00 case for Min/MaxWorkingHour
      const minWH = shiftData.MinWorkingHour === "24:00" ? "23:59:59.999" : shiftData.MinWorkingHour;
      const maxWH = shiftData.MaxWorkingHour === "24:00" ? "23:59:59.999" : shiftData.MaxWorkingHour;

      const wroktimeMs = worktimeFormat === "24:00"
        ? 24 * 60 * 60 * 1000
        : new Date(`${dateString}T${worktimeFormat}:00Z`).getTime();

      const minimumWorkTimeMs = shiftData.MinWorkingHour === "24:00"
        ? 24 * 60 * 60 * 1000
        : new Date(`${dateString}T${minWH}:00Z`).getTime();

      const maximumWorkTimeMs = shiftData.MaxWorkingHour === "24:00"
        ? 24 * 60 * 60 * 1000
        : new Date(`${dateString}T${maxWH}:00Z`).getTime();

      setLoading(true);
      const response = await insertShift({
        ...shiftData,
        // Pass the original values (including 24:00) to the API
        StartTime: shiftData.StartTime,
        EndTime: shiftData.EndTime,
        MinWorkingHour: shiftData.MinWorkingHour,
        MaxWorkingHour: shiftData.MaxWorkingHour
      });

      if (response.data.StatusCode === 200) {
        toast.success(response.data.message);
        fetchShifts();
        openEditShiftModal();
      }
    } catch (error) {
      toast.error("Something went wrong, please try again");
      console.error("Error editing shift:", error);
    } finally {
      setLoading(false);
    }
  };


  const departementOption = Department?.map((el) => ({
    value: el.Id,
    label: el.Name,
  }));
  const handleMultiSelectChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map((option) => option.value) : [];
    setShiftData((prevState) => ({
      ...prevState,
      DepartmentId: selectedValues, // Store as an array
    }));
  };

  // Category fetch
  useEffect(() => {
    const fetchCategorys = async () => {
      try {
        const response = await getCategorys(UID);


        setCategorys(response.data.data);
      } catch (error) {
        console.error("Error fetching Categorys:", error);
      }
    };

    fetchCategorys();
  }, []);


  const clearData = () => {
    setShiftData({
      Name: "",
      Narration: "",
      StartTime: "",
      EndTime: "",
      MinOverTime: "",
      MinWorkingHour: "",
      MaxWorkingHour: "",
      HalfDay: "",
      GracePeriod: "",
      Remarks: "",
      UserId: UID,
    });
  };

  const clearDataForEdit = () => {
    setShiftData((ref) => ({
      ...ref, // Spread the previous state
      Name: "",
      Narration: "",
      StartTime: "",
      EndTime: "",
      MinOverTime: "",
      MinWorkingHour: "",
      HalfDay: "",
      MaxWorkingHour: "",
      GracePeriod: "",
      Remarks: "",
      UserId: UID,
    }));
  };

  const [deleteShiftTypeId, setDeleteShiftTypeId] = useState(null); // Correct naming convention
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (payScaleId) => {
    setDeleteShiftTypeId(payScaleId);
    setIsModalOpen(true);
  };

  // Close the modal and reset the state
  const closeModal = () => {
    setIsModalOpen(false);
    setDeleteShiftTypeId(null);
  };

  // Trigger the delete operation and close the modal
  const confirmDelete = () => {
    if (deleteShiftTypeId) {
      handleDelete(deleteShiftTypeId); // Ensure handleDelete is defined correctly
    }
    closeModal();
  };

  const handleDelete = async (shiftId) => {
    const removeData = { Id: shiftId, TableName: "Shift" };
    try {
      const res = await deleteShift(removeData, UID);
      if (res && res.data) {
        // Ensure the response has the expected structure
        if (res.status === 200 && res.data.message === "Deleted Successfully") {
          toast.success("Shift deleted successfully");
          fetchShifts(); // Refresh the list
        } else {
          toast.error(
            res.data.message || "Unexpected response from the server."
          );
        }
      } else {
        toast.error("Error deleting Shift");
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting Shift.";
        toast.error("Shift already using cannot delete");
      } else {
        console.error("Error removing Shift:", error);
        toast.error("Error deleting Shift. Please try again.");
      }
    }
  };
  //


  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "Shift Name",
      selector: (row) => row.Name,
      sortable: true,
      width: "350px",
    },
    {
      name: "Start Time",
      selector: (row) => row.StartTime || "",
      sortable: true,
    },
    {
      name: "End Time",
      selector: (row) => row.EndTime || "",
      sortable: true,
    },

    {
      name: "Min Over Time",
      selector: (row) => row.MinOverTime || "",
      sortable: true,
    },
    {
      name: "Min Working Hour",
      selector: (row) =>


        row.MinWorkingHour == "00:00" ? "24:00" :
          row.MinWorkingHour
      ,
      sortable: true,
    },


    {
      name: "Max Working Hour",
      selector: (row) =>
        row.MaxWorkingHour == "00:00" ? "24:00" :
          row.MaxWorkingHour,
      sortable: true,
    },
    {
      name: "Grace Period",
      selector: (row) => row.GracePeriod || "",
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditShiftModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];


  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const filteredItems = dataFilter.filter(
    (item) =>
      // item.Id.toLowerCase().includes(filterText.toLowerCase()) ||
      item.Name.toLowerCase().includes(filterText.toLowerCase()) ||
      item.Code?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.Narration?.toLowerCase().includes(filterText.toLowerCase())
  );


  const fetchCompanyDetails = async () => {
    try {
      const response = await getCompanys(UID);
      setCompanyDetails(response.data.data[0]);
      console.log(response.data.data[0], 'Response Data');
    } catch (error) {
      console.error('An error occurred:', error);
      toast.error('An error occurred while fetching company details');
    }
  };

  useEffect(() => {
    fetchCompanyDetails();
  }, []);

  const downloadPdf = () => {
    console.log(companyDetails, 'Generating PDF...');

    const doc = new jsPDF();

    // Centered heading
    const pageWidth = doc.internal.pageSize.getWidth();
    const heading = `Shift Details ON ${companyDetails?.Name || 'Company'}`;
    const textWidth = doc.getTextWidth(heading);
    const xOffset = (pageWidth - textWidth) / 2;
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text(heading, xOffset, 10);

    // Table Head
    const tableHead = [["Sl No", "Shift Name", "Start Time", "End Time", "Grace Period"]];

    // Table Body from filteredItems
    const tableBody = filteredItems.map((item) => [
      item.Slno || "",
      item.Name || "",
      item.StartTime || "",
      item.EndTime || "",
      item.GracePeriod || "",
    ]);

    // Table styling with black borders and white background
    doc.autoTable({
      head: tableHead,
      body: tableBody,
      startY: 20,
      theme: 'grid',
      headStyles: {
        fillColor: [255, 255, 255], // White background for header
        textColor: [0, 0, 0], // Black text
        lineWidth: 0.2, // Black border width
        lineColor: [0, 0, 0], // Black border color
        fontStyle: 'bold',
        halign: 'center', // Center header text
      },
      bodyStyles: {
        fillColor: [255, 255, 255], // White background for rows
        textColor: [0, 0, 0], // Black text
        lineWidth: 0.2, // Black border width
        lineColor: [0, 0, 0], // Black border color
        halign: 'center', // Center body text
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255], // Ensure alternate rows are also white
      },
      margin: { top: 20 },
      styles: {
        font: 'helvetica',
        fontSize: 10,
        cellPadding: 2,
      },
    });

    doc.save("ShiftDetails.pdf");
  };




  const subHeaderComponentMemo = useMemo(() => {

  }, [filterText, resetPaginationToggle]);

  const formatTimee = (time) => {
    // Split the input time into hours and minutes
    const [hours, minutes] = time.split(":");

    // Pad hours and minutes with leading zeros if necessary
    const formattedHours = hours?.padStart(2, "0");
    const formattedMinutes = minutes?.padStart(2, "0");

    // Return the formatted time as HH:MM
    return `${formattedHours}:${formattedMinutes}`;
  };
  useEffect(() => {
    const calculateWorkingHours = () => {
      const { StartTime, EndTime } = shiftData;

      if (StartTime && EndTime) {
        // Special case for 24-hour shift
        if (StartTime === "00:00" && EndTime === "00:00") {
          setShiftData(prev => ({
            ...prev,
            WorkingHour: "24:00",
            MinWorkingHour: "24:00",
            MaxWorkingHour: "24:00"
          }));
          return;
        }

        const today = new Date();
        const dateString = today.toISOString().split('T')[0];
        const start = new Date(`${dateString}T${StartTime}:00`);
        const end = new Date(`${dateString}T${EndTime}:00`);

        // Handle overnight shifts
        if (end <= start) {
          end.setDate(end.getDate() + 1);
        }

        const diff = end - start;
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        setShiftData(prev => ({
          ...prev,
          WorkingHour: `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`,
        }));
      } else {
        setShiftData(prev => ({ ...prev, WorkingHour: '' }));
      }
    };

    calculateWorkingHours();
  }, [shiftData.StartTime, shiftData.EndTime]);


  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);  // Update state with the filtered data
  };


  useEffect(() => {
    console.log(dataFilter, 'dasdasd');

  }, [dataFilter])

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this Shift?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex items-center justify-between mb-8">
        <Breadcrumb title="Shift" />

        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search by Shift"
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={handleClear}
              className="btn btn-danger"
            >
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button
            onClick={openAddShiftModal}
            className="btn btn-primary"
          >
            Add New
          </button>
          <button
            onClick={downloadPdf}
            className="btn btn-danger"
          >
            PDF
          </button>
        </div>
      </div>


      {isFilterVisible && (
        <FilterComponent columns={columnsFilter} data={shifts} onFilter={handleFilter} />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">

        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>
      {addShiftModal && (
        <>
          <form onSubmit={handleSubmit}>
            <div className="fixed inset-0 flex items-center justify-center z-[60] bg-black/30">
              <div className="w-full max-w-[600px] bg-bg-dark rounded-lg shadow-light p-6 md:p-10 flex flex-col max-h-[90vh] overflow-hidden">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Add Shift
                  <span className="absolute top-0 right-0">
                    <button
                      onClick={openAddShiftModal}
                      className="btn flex items-center justify-center"
                    >
                      ✖
                    </button>
                  </span>
                </h5>
                <div className="my-10 lg:px-10 md:px-10 px-[7px] h-[600px] overflow-auto">
                  {/* Row 1: Shift Name | Start Time */}
                  <div className="grid grid-cols-12 gap-6 mb-10">
                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>
                        Shift Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="Name"
                        placeholder="Name"
                        value={shiftData.Name}
                        onChange={handleChange}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                      />
                    </div>

                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>
                        Start Time <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="time"
                        id="startTime"
                        name="StartTime"
                        placeholder="StartTime"
                        value={shiftData.StartTime}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* Row 2: End Time | Working Hour */}
                  <div className="grid grid-cols-12 gap-6 mb-10">
                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>
                        End Time <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="time"
                        id="endTime"
                        name="EndTime"
                        placeholder="EndTime"
                        value={shiftData.EndTime}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>Working Hour (HH:MM)</label>
                      <input
                        type="text"
                        id="minWorkingHour"
                        name="MinWorkingHour"
                        placeholder="HH:MM"
                        value={shiftData.WorkingHour}
                        readOnly
                      />
                    </div>
                  </div>

                  {/* Row 3: Min Working Hour | Max Working Hour */}
                  <div className="grid grid-cols-12 gap-6 mb-10">
                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>
                        Min Working Hour (HH:MM) <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="MinWorkingHour"
                        value={shiftData.MinWorkingHour}
                        onChange={handleChange}
                        placeholder="HH:MM"
                        onBlur={handleBlur}
                        disabled={!shiftData.WorkingHour}
                        style={{
                          borderColor: shiftData?.MinWorkingHourError ? "red" : "",
                        }}
                      />
                      {shiftData?.MinWorkingHourError && (
                        <p style={{ color: "red" }}>{shiftData?.MinWorkingHourError}</p>
                      )}
                    </div>

                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>
                        Max Working Hour (HH:MM) <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="MaxWorkingHour"
                        value={shiftData.MaxWorkingHour}
                        onChange={handleChange}
                        placeholder="HH:MM"
                        onBlur={handleBlur}
                        disabled={!shiftData.WorkingHour}
                        style={{
                          borderColor: shiftData.MaxWorkingHourError ? "red" : "",
                        }}
                      />
                      {shiftData.MaxWorkingHour &&
                        shiftData.MaxWorkingHourError && (
                          <p style={{ color: "red" }}>
                            {shiftData.MaxWorkingHourError}
                          </p>
                        )}
                    </div>
                  </div>

                  {/* Row 4: Min Over Time | Grace Period */}
                  <div className="grid grid-cols-12 gap-6 mb-10">
                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>Min Over Time (HH:MM)</label>
                      <input
                        type="text"
                        id="MinOverTime"
                        name="MinOverTime"
                        placeholder="HH:MM"
                        value={shiftData.MinOverTime}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{
                          borderColor: shiftData.MinOverTimeError ? "red" : "",
                        }}
                      />
                      {shiftData.MinOverTime && shiftData.MinOverTimeError && (
                        <p style={{ color: "red" }}>
                          {shiftData.MinOverTimeError}
                        </p>
                      )}
                    </div>

                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>Grace Period (in Minutes)</label>
                      <input
                        type="number"
                        id="gracePeriod"
                        name="GracePeriod"
                        placeholder="GracePeriod"
                        value={shiftData.GracePeriod}
                        onChange={handleChange}
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>

                  {/* Row 5: Remarks | Allow HalfDay */}
                  <div className="grid grid-cols-12 gap-6 mb-10">
                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="remark"
                        name="Remarks"
                        placeholder="Remarks"
                        value={shiftData.Remarks}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-group col-span-12 md:col-span-6 flex items-center justify-between p-3 rounded">
                      <label className="font-medium">HalfDay</label>
                      <input
                        type="checkbox"
                        id="allowHalfday"
                        name="allowHalfday"
                        checked={shiftData.allowHalfday === true}
                        onChange={handleChange}
                      />
                    </div>

                  </div>

                  {/* Half Day Fields - Show when checkbox is checked */}
                  {shiftData.allowHalfday == true && (
                    <>
                      {/* Row 6: Start Time (MH) | End Time (MH) */}
                      <div className="grid grid-cols-12 gap-6 mb-10">
                        <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                          <label>
                            Start Time (MH) <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="time"
                            id="StartMH"
                            name="HalfDayStartTimeMorning"
                            placeholder="StartTime MorningHalfDay"
                            value={shiftData.HalfDayStartTimeMorning}
                            onChange={handleChange}
                            required={shiftData.allowHalfday == true}
                          />
                        </div>

                        <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                          <label>
                            End Time (MH) <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="time"
                            id="EndMH"
                            name="HalfDayEndTimeMorning"
                            placeholder="End time Morning HalfDay"
                            value={shiftData.HalfDayEndTimeMorning}
                            onChange={handleChange}
                            required={shiftData.allowHalfday == true}
                          />
                        </div>
                      </div>

                      {/* Row 7: Working Hour (MH) | Start Time (EH) */}
                      <div className="grid grid-cols-12 gap-6 mb-10">
                        <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                          <label>Working Hour (MH) (HH:MM)</label>
                          <input
                            type="text"
                            id="WorkingHourMorningHalfDay"
                            name="WorkingHourMorningHalfDay"
                            placeholder="HH:MM"
                            value={shiftData.WorkingHourMorningHalfDay}
                            required={shiftData.allowHalfday == true}
                          />
                        </div>

                        <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                          <label>
                            Start Time (EH) <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="time"
                            id="StartEH"
                            name="HalfDayStartTimeEvening"
                            placeholder="StartTime EveningHalfDay"
                            value={shiftData.HalfDayStartTimeEvening}
                            onChange={handleChange}
                            required={shiftData.allowHalfday == true}
                          />
                        </div>
                      </div>

                      {/* Row 8: End Time (EH) | Working Hour (EH) */}
                      <div className="grid grid-cols-12 gap-6 mb-10">
                        <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                          <label>
                            End Time (EH) <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="time"
                            id="EndEH"
                            name="HalfDayEndTimeEvening"
                            placeholder="End time Evening HalfDay"
                            value={shiftData.HalfDayEndTimeEvening}
                            onChange={handleChange}
                            required={shiftData.allowHalfday == true}
                          />
                        </div>

                        <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                          <label>Working Hour (EH) (HH:MM)</label>
                          <input
                            type="text"
                            id="WorkingHourEH"
                            name="WorkingHourEveningHalfDay"
                            placeholder="HH:MM"
                            value={shiftData.WorkingHourEveningHalfDay}
                            required={shiftData.allowHalfday == true}
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {/* Row: Department - Full Width */}
                  <div className="grid grid-cols-12 gap-6">
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Department</label>
                      <Select
                        name="DepartmentId"
                        value={departementOption.filter((option) =>
                          shiftData.DepartmentId?.includes(option.value)
                        )}
                        onChange={handleMultiSelectChange}
                        options={departementOption}
                        isMulti
                        placeholder="Select Departments"
                      />
                    </div>
                  </div>
                </div>

                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={
                      loading ||
                      !shiftData.StartTime ||
                      !shiftData.EndTime ||
                      shiftData.MinWorkingHourError ||
                      shiftData.MaxWorkingHourError ||
                      (shiftData.StartTime === "00:00" &&
                        shiftData.EndTime === "00:00" &&
                        (shiftData.MinWorkingHour !== "24:00" ||
                          shiftData.MaxWorkingHour !== "24:00")) ||
                      (!shiftData.MinWorkingHour ||
                        !shiftData.MaxWorkingHour)
                    }
                  >
                    {loading ? "Loading..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </form>

          <div
            // onClick={openAddShiftModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
      {/* ===============================================edit-====================================== */}

      {editShiftModal && (
        <>
          <form onSubmit={handleEdit}>
            <div className="fixed inset-0 flex items-center justify-center z-[60] bg-black/30">
              <div className="w-full max-w-[600px] bg-bg-dark rounded-lg shadow-light p-6 md:p-10 flex flex-col max-h-[90vh] overflow-hidden">

                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Edit Shift
                  <span className="absolute top-0 right-0">
                    <button
                      onClick={openEditShiftModal}
                      className="btn flex items-center justify-center"
                    >
                      ✖
                    </button>
                  </span>
                </h5>
                <div className="my-10 md:px-10 px-[7px] h-[600px] overflow-y-scroll">
                  {/* Row 1: Shift Name | Start Time */}
                  <div className="grid grid-cols-12 gap-6 mb-10">
                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>
                        Shift Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="Name"
                        name="Name"
                        placeholder="Name"
                        value={shiftData.Name}
                        onChange={handleChange}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                      />
                    </div>

                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>
                        Start Time <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="time"
                        id="StartTime"
                        name="StartTime"
                        placeholder="StartTime"
                        value={formatTimee(shiftData.StartTime)}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* Row 2: End Time | Working Hour */}
                  <div className="grid grid-cols-12 gap-6 mb-10">
                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>
                        End Time <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="time"
                        id="EndTime"
                        name="EndTime"
                        placeholder="EndTime"
                        value={formatTimee(shiftData.EndTime)}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>Working Hour (HH:MM)</label>
                      <input
                        type="text"
                        id="WorkingHour"
                        name="WorkingHour"
                        placeholder="HH:MM"
                        value={shiftData.WorkingHour}
                        readOnly
                      />
                    </div>
                  </div>

                  {/* Row 3: Min Working Hour | Max Working Hour */}
                  <div className="grid grid-cols-12 gap-6 mb-10">
                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>
                        Min Working Hour (HH:MM) <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="MinWorkingHour"
                        name="MinWorkingHour"
                        placeholder="HH:MM"
                        value={shiftData.MinWorkingHour == "00:00" ? "24:00" : shiftData.MinWorkingHour}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                        style={{
                          borderColor: shiftData.MinWorkingHourError ? "red" : "",
                        }}
                      />
                      {shiftData.MinWorkingHourError && (
                        <p style={{ color: "red" }}>{shiftData.MinWorkingHourError}</p>
                      )}
                    </div>

                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>
                        Max Working Hour (HH:MM) <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="MaxWorkingHour"
                        name="MaxWorkingHour"
                        placeholder="HH:MM"
                        value={shiftData.MaxWorkingHour == "00:00" ? "24:00" : shiftData.MaxWorkingHour}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                        style={{
                          borderColor: shiftData.MaxWorkingHourError ? "red" : "",
                        }}
                      />
                      {shiftData.MaxWorkingHourError && (
                        <p style={{ color: "red" }}>{shiftData.MaxWorkingHourError}</p>
                      )}
                    </div>
                  </div>

                  {/* Row 4: Min Over Time | Grace Period */}
                  <div className="grid grid-cols-12 gap-6 mb-10">
                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>Min Over Time (HH:MM)</label>
                      <input
                        type="text"
                        id="MinOverTime"
                        name="MinOverTime"
                        placeholder="HH:MM"
                        value={shiftData.MinOverTime}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{
                          borderColor: shiftData.MinOverTimeError ? "red" : "",
                        }}
                      />
                      {shiftData?.MinOverTimeError && (
                        <p style={{ color: "red" }}>{shiftData.MinOverTimeError}</p>
                      )}
                    </div>

                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>Grace Period (in Minutes)</label>
                      <input
                        type="number"
                        id="GracePeriod"
                        name="GracePeriod"
                        placeholder="GracePeriod"
                        value={shiftData.GracePeriod}
                        onChange={handleChange}
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>

                  {/* Row 5: Remarks | Allow HalfDay */}
                  <div className="grid grid-cols-12 gap-6 mb-10">
                    <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="Remarks"
                        name="Remarks"
                        placeholder="Remarks"
                        value={shiftData.Remarks}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-group col-span-12 md:col-span-6 flex items-center gap-2">
                      <label className="font-medium">HalfDay</label>
                      <input
                        type="checkbox"
                        id="allowHalfday"
                        name="allowHalfday"
                        checked={shiftData.allowHalfday === true}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Half Day Fields - Show when checkbox is checked */}
                  {shiftData.allowHalfday == true && (
                    <>
                      {/* Row 6: Start Time (MH) | End Time (MH) */}
                      <div className="grid grid-cols-12 gap-6 mb-10">
                        <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                          <label>
                            Start Time (MorningHalfDay) <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="time"
                            id="StartMH"
                            name="HalfDayStartTimeMorning"
                            placeholder="StartTime MorningHalfDay"
                            value={shiftData.HalfDayStartTimeMorning}
                            onChange={handleChange}
                            required={shiftData.allowHalfday == true}
                          />
                        </div>

                        <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                          <label>
                            End Time (MorningHalfDay) <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="time"
                            id="EndMH"
                            name="HalfDayEndTimeMorning"
                            placeholder="End time Morning HalfDay"
                            value={shiftData.HalfDayEndTimeMorning}
                            onChange={handleChange}
                            required={shiftData.allowHalfday == true}
                          />
                        </div>
                      </div>

                      {/* Row 7: Working Hour (MH) | Start Time (EH) */}
                      <div className="grid grid-cols-12 gap-6 mb-10">
                        <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                          <label>Working Hour (MorningHalfDay)a</label>
                          <input
                            type="text"
                            id="WorkingHourMorningHalfDay"
                            name="WorkingHourMorningHalfDay"
                            placeholder="HH:MM"
                            value={shiftData.WorkingHourMorningHalfDay}
                            readOnly
                            required={shiftData.allowHalfday == true}
                          />
                        </div>

                        <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                          <label>
                            Start Time (EveningHalfDay) <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="time"
                            id="StartEH"
                            name="HalfDayStartTimeEvening"
                            placeholder="StartTime EveningHalfDay"
                            value={shiftData.HalfDayStartTimeEvening}
                            onChange={handleChange}
                            required={shiftData.allowHalfday == true}
                          />
                        </div>
                      </div>

                      {/* Row 8: End Time (EH) | Working Hour (EH) */}
                      <div className="grid grid-cols-12 gap-6 mb-10">
                        <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                          <label>
                            End Time (EveningHalfDay) <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="time"
                            id="EndEH"
                            name="HalfDayEndTimeEvening"
                            placeholder="End time Evening HalfDay"
                            value={shiftData.HalfDayEndTimeEvening}
                            onChange={handleChange}
                            required={shiftData.allowHalfday == true}
                          />
                        </div>

                        <div className="form-group col-span-12 md:col-span-6 flex flex-col gap-2">
                          <label>Working Hour (EveningHalfDay)</label>
                          <input
                            type="text"
                            id="WorkingHourEH"
                            name="WorkingHourEveningHalfDay"
                            placeholder="HH:MM"
                            value={shiftData.WorkingHourEveningHalfDay}
                            readOnly
                            required={shiftData.allowHalfday == true}
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {/* Row: Department - Full Width */}
                  <div className="grid grid-cols-12 gap-6">
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Department</label>
                      <Select
                        name="DepartmentId"
                        value={departementOption.filter((option) =>
                          shiftData.DepartmentId?.includes(option.value)
                        )}
                        onChange={handleMultiSelectChange}
                        options={departementOption}
                        isMulti
                        placeholder="Select Departments"
                      />
                    </div>
                  </div>
                </div>

                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearDataForEdit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={
                      loading ||
                      !shiftData.StartTime ||
                      !shiftData.EndTime ||
                      shiftData.MinWorkingHourError ||
                      shiftData.MaxWorkingHourError ||
                      !shiftData.MinWorkingHour ||
                      !shiftData.MaxWorkingHour
                    }
                  >
                    {loading ? "Loading..." : "Edit"}
                  </button>
                </div>
              </div>
            </div>
          </form>

          <div
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
    </>
  );
}
